module.exports = __webpack_public_path__ + "media/customizations/unionparklife/back-353c51af537b6aa76510b6b372e0f25f.jpg";